import type { RouteObject } from 'react-router'

import { routeCrumb } from '../client/components/Admin/TopNavBar/utils/routeCrumb.js'

export const templatesRoute: RouteObject = {
  // TODO: decide to keep this or not
  path: 'customizer/templates',
  async lazy() {
    const { Templates } = await import(
      '../client/components/Admin/Templates/index.js'
    )
    const { Container } = await import('@tribeplatform/react-ui-kit/Layout')

    return {
      element: (
        <Container
          size="full"
          padding={{
            vertical: 'md',
            horizontal: { size: 'md', disableOnMobile: true },
          }}
        >
          <Templates />
        </Container>
      ),
    }
  },
}

export const miscRoutes: RouteObject = {
  async lazy() {
    const { RouteContainer } = await import(
      '../client/components/Container/RouteContainer.js'
    )

    return { Component: RouteContainer }
  },
  children: [
    {
      path: 'dashboard/whats-new',
      async lazy() {
        const { WhatsNew } = await import(
          '../client/components/Admin/Dashboard/WhatsNew.js'
        )

        return { Component: WhatsNew }
      },
    },
    {
      path: 'onboarding',
      async lazy() {
        const { NewOnboarding, OnboardingBreadCrumb } = await import(
          '../client/components/Admin/Onboarding/NewOnboarding/NewOnboarding.js'
        )

        return {
          Component: NewOnboarding,
          handle: routeCrumb(OnboardingBreadCrumb),
        }
      },
    },
  ],
}
